








































import * as utils from '@ivy/fts/utils'
import { env } from '@ivy/fts/envInfo/envInfo'
import areacodePanel from './areacodePanel.vue'
import * as qs from 'qs'
import { Component, Prop, Vue } from 'vue-property-decorator'
import { requirePost } from '../require'

@Component({
  components: { areacodePanel },
})
export default class BindMobile extends Vue {
  @Prop() channelId: number
  @Prop() actId: number
  bind = {
    mobile: '',
    vercode: '',
  }
  area = {
    area_code: '+86',
    area_code_id: '1',
  }
  getCode = {
    text: '获取验证码',
    geting: false,
  }
  redirectUrl: string = null
  showPanel = false
  loading = false
  queryObj: any = {}
  wxAd: any = null
  order: any = {}
  setAreaCode(area) {
    this.area = area
    this.showPanel = false
  }
  get codeStyle() {
    return {
      color: this.getCode.geting ? '#CCCCCC' : '#00B097',
    }
  }
  async created() {
    try {
      sessionStorage.setItem(Math.random() + '', '1')
    } catch (e) {
      this.$Toast(
        '您的浏览器开启了无痕浏览，如果遇到功能异常的情况，建议关闭无痕浏览'
      )
    }
    if (this.redirectUrl) {
      const index = this.redirectUrl.indexOf('?')
      if (index !== -1) {
        const queryObj = qs.parse(this.redirectUrl.slice(index + 1)) || {}
        this.queryObj = queryObj
      }
    }
  }
  async openAreaCode() {
    this.showPanel = true
  }
  getPhone() {
    return this.bind.mobile
      .split(' ')
      .join('')
      .split('-')
      .join('')
  }
  async verifyCode(e) {
    // if (utils.isWeixin() && !utils.cacheGet(`code-${config.appid}`)) {
    //   return await this.$store.login()
    // }
    await env.init()
    if (env.type === 'web') return this.$Toast('请在微信中打开')
    if (!(await env.getIsLogin())) {
      return await env.login()
    }
  }
  async bindMobile() {
    if (this.loading) {
      return
    }
    if (!this.bind.mobile) {
      return this.$Toast('请输入手机号')
    }
    if (!this.bind.vercode) {
      return this.$Toast('请输入短信验证码')
    }
    this.loading = true
    await this.$store
      .bindPhone({
        area_code_id: this.area.area_code_id,
        smscode: this.bind.vercode,
        phone: this.getPhone(),
        app_name: this.queryObj._cookieRegister,
      })
      .catch(e => (this.loading = false))
    // if (!this.$store.logined.token) {
    //   // 绑定手机号失败
    //   this.loading = false
    //   return
    // }
    this.$Toast('手机号绑定成功')
    try {
      sessionStorage.setItem('login_token', this.$store.logined.token)
    } catch (e) {
      this.$Toast(
        '您的浏览器开启了无痕浏览，如果遇到功能异常的情况，建议关闭无痕浏览'
      )
    }
    this.$emit('verifyLogin')
  }
  async countDown() {
    this.getCode.geting = true
    for (let count = 60; count > 0; count--) {
      this.getCode.text = `重新获取  ${count}s`
      await utils.sleep(1000)
    }
    this.getCode = {
      text: '获取验证码',
      geting: false,
    }
  }
  async toGetCode() {
    // 获取验证码
    if (this.getCode.geting) return
    if (!this.bind.mobile) {
      return this.$Toast('请输入手机号')
    }
    const {
      data: { code, message },
    } = await requirePost(`/api/core/user/member/sendSmsCode`, {
      mobile_prefix_id: this.area.area_code_id,
      telephone: this.getPhone(),
      verify_code_type: 5,
    })
    if (code) {
      return this.$Toast('验证码发送失败！' + message)
    }
    this.$Toast('验证码发送成功')
    this.countDown()
  }
}
